import { Popover } from "antd";
import { useTranslation } from "react-i18next";
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { renderIcon } from "../../../../EditCADD/templates/project/projectSources/components/ItemsList";

export const Item = ({ item = {} }) => {
  const { t } = useTranslation();
  const { isOwnData } = item || {};

  const renderDatastakeId = () => {
    if ((item.status || []).includes('approved')) {
      return item.data?.userId || '';
    }

    if (item.emailOrDSID === 'datastakeId') {
      return item.data?.userId || '';
    }

    return '--';
  };

  const renderName = () => {
    if (item.isOwnData) {
      return t('Own Data');
    }

    return item.sourceName || item.data?.name || '';
  };

  const email = item.emailOrDSID === 'email' || item.isOwnData ? item.data?.email || '' : '--';
  const orgName = (item.status || []).includes('approved') ? item.data?.name || '' : '--'

  return (
    <div className={formatClassname(['px-md item'])}>
      <div className="item-header">
        <div className="flex-1 flex-column">
          <label>{renderName()}</label>
        </div>
        <div className="flex-column">
          {renderIcon({ t, isOwnData, item })}
        </div>
      </div>

      <div className="info">
        <div className="row-item">
          <div className="left">
            <label>{t('Organisation Name')}</label>
          </div>
          <div className="right">
            <label>{orgName}</label>
          </div>
        </div>
        <div className="row-item">
          <div className="left">
            <label>{t('Datastake ID')}</label>
          </div>
          <div className="right">
            <label>{renderDatastakeId()}</label>
          </div>
        </div>
        <div className="row-item">
          <div className="left">
            <label>{t('Email')}</label>
          </div>
          <div className="right">
            <label>{email}</label>
          </div>
        </div>
        <div className="row-item">
          <div className="left">
            <label>{t('Shared Subjects')}</label>
          </div>
          <div className="right logos">
            {(item.shareInfo || []).length === 0 && <label>--</label>}
            {(item.shareInfo || []).includes('locations') && (
              <div className="flex-column">
                <Popover content={t('Locations')}>
                  <img src="/assets/images/project-share-info/location.svg" alt="location" />
                </Popover>
              </div>
            )}
            {(item.shareInfo || []).includes('stakeholders') && (
              <div className="flex-column">
                <Popover content={t('Stakeholders')}>
                  <img src="/assets/images/project-share-info/stakeholder.svg" alt="location" />
                </Popover>
              </div>
            )}
            {(item.shareInfo || []).includes('events') && (
              <div className="flex-column">
                <Popover content={t('Events')}>
                  <img src="/assets/images/project-share-info/event.svg" alt="location" />
                </Popover>
              </div>
            )}
            {(item.shareInfo || []).includes('network') && (
              <div className="flex-column">
                <Popover content={t('LIRs')}>
                  <img src="/assets/images/project-share-info/network.svg" alt="location" />
                </Popover>
              </div>
            )}
            {(item.shareInfo || []).includes('dueDiligence') && (
              <div className="flex-column">
                <Popover content={t('Due Diligence')}>
                  <img src="/assets/images/project-share-info/due-dilligence.svg" alt="location" />
                </Popover>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
